import Vue from 'vue';
import VueI18n from "vue-i18n";
import en from "@/locales/en.json";
import zhCN from "@/locales/zhCN.json";
import zhHK from "@/locales/zhHK.json";
import WebResources_en from "@/locales/WebResources/en.json";
import WebResources_zhCN from "@/locales/WebResources/zhCN.json";
import WebResources_zhHK from "@/locales/WebResources/zhHK.json";
import { defaultLocale, localeOptions } from "@/constants/config";

Vue.use(VueI18n);

var locale =
    localStorage.getItem("currentLanguage") &&
    localeOptions.filter((x) => x.id === localStorage.getItem("currentLanguage")).length > 0
        ? localStorage.getItem("currentLanguage")
        : defaultLocale;
var currentLang = localeOptions.filter((x) => x.id === locale)[0];
let urlParams = new URLSearchParams(window.location.search);
var langid = urlParams.get("langid");
if (langid > 0) {
    currentLang = localeOptions.filter((x) => x.langid.toString() === langid.toString())[0];
    locale = currentLang.id;
}
// 处理 lang 参数 (如 lang=simp, lang=trad, lang=eng)
var langParam = urlParams.get("lang");
if (langParam) {
    var langOption = localeOptions.filter((x) => x.lang === langParam.toLowerCase())[0];
    if (langOption) {
        currentLang = langOption;
        locale = currentLang.id;
    }
}

export const currentLangId = currentLang.langid;

localStorage.setItem("currentLanguage", currentLang.id);
localStorage.setItem("currentLanguageName", currentLang.name);
localStorage.setItem("currentLanguageIcon", currentLang.icon);
localStorage.setItem("currentLangId", currentLangId);
localStorage.setItem("currentLang", currentLang.lang);

const i18n = new VueI18n({
    locale,
    fallbackLocale: "zhCN",
    messages: {
      en: en
    },
    silentTranslationWarn: true,
});

i18n.setLocaleMessage("zhHK", zhHK);
i18n.setLocaleMessage("zhCN", zhCN);

i18n.mergeLocaleMessage("en", WebResources_en);
i18n.mergeLocaleMessage("zhHK", WebResources_zhHK);
i18n.mergeLocaleMessage("zhCN", WebResources_zhCN);

export default i18n;
